import Promise from 'bluebird';
import axiosInstance from '../../shared/utils/axios';
import debug from 'debug';
import store, {_openModal} from '../../shared/store';

const log = debug('circleblack:advisor:defaultContainerID');

let defaultContainerID = 0;

/* --- actions ---*/
const GET_DEFAULT_CONTAINER_ID = 'GET_DEFAULT_CONTAINER_ID';
const CLEAR_DEFAULT_CONTAINER_ID = 'CLEAR_DEFAULT_CONTAINER_ID';

/**
 * Dispatches GET_DEFAULT_CONTAINER_ID gathering the default container for the user based on role
 * @param {Boolean} [force] If true forces refresh instead of using existing
 * @param {String} [role] A User Role to use instead of user's role to allow managers to default to their advisor container
 * @return {function(*): (*)}
 */
export const _getDefaultContainerID = (force, role) => dispatch => {
  const user = store.getState().session;
  let op;
  if (!force && defaultContainerID) {
    return Promise.resolve(dispatch({type: GET_DEFAULT_CONTAINER_ID, containerID: defaultContainerID}));
  }
  switch (role || user.profile.role) {
    case 'ADVISOR':
      op = axiosInstance.get(`/advisors/${user.profile.id}/containers`)
        .then(res => res.data.find(c => c.type === 'ADVISOR' && c.highLevel === 'ASSETS'));
      break;
    case 'BRANCHMGR':
      op = axiosInstance.get('/branches')
        .then(res => {
          const branch = res.data[0];
          if (!branch) {
            return {};
          }
          return axiosInstance.get(`/branches/${branch.id}/containers`);
        })
        .then(res => res.data.find(c => c.type === 'BRANCH' && c.highLevel === 'ASSETS'));
      break;
    case 'FIRMMGR':
    case 'CPLO':
      op = axiosInstance.get(`/firms/${user.profile.firm.id}/containers`)
        .then(res => res.data.find(c => c.type === 'FIRM' && c.highLevel === 'ASSETS'));
      break;
    case 'ASSOC':
    case 'PRODMGR':
    case 'PRODSUPP':
    default:
      // ETODO Better error handling
      // return alert(`logout as you are a ${user.role} and logged into the wrong ui`);
      log(`logout as you are a ${user.role} and logged into the wrong ui`);
  }
  return op
    .then(container => {
      dispatch({
        type: GET_DEFAULT_CONTAINER_ID,
        containerID: container.id,
      });
      return container.id;
    })
    .catch(err => dispatch(_openModal({type: 'Error', err: err})));
};

export const _clearDefaultContainerID = () => dispatch => dispatch({type: CLEAR_DEFAULT_CONTAINER_ID, containerID: 0});

/* --- reducer ---*/
export default function reducer(state = defaultContainerID, action) {
  let newState = {...state};

  switch (action.type) {
    case GET_DEFAULT_CONTAINER_ID:
      defaultContainerID = action.containerID;
      newState = action.containerID;
      break;
    case CLEAR_DEFAULT_CONTAINER_ID:
      defaultContainerID = action.containerID;
      newState = action.containerID;
      break;
    default:
      return state;
  }
  return newState;
}
